<template>
  <div class="d-flex align-center">
    <v-skeleton-loader v-if="!restaurant" type="paragraph" />
    <template v-else>
      <v-img
        class="logo mr-2"
        :max-width="imgSize"
        :max-height="imgSize"
        :width="imgSize"
        :height="imgSize"
        style="border-radius: 8px; overflow: hidden"
        :src="
          restaurant.logo
            ? `${uploadsPath}/${restaurant.logo}`
            : `assets/img/restaurant-logo.png`
        "
      ></v-img>
      <div class="d-flex flex-column">
        <div class="children-inline">
          <h3>{{ restaurant.name }}</h3>
          <v-btn
            icon
            x-small
            :href="`https://${domain}/${restaurant.stringId}`"
            target="_blank"
            ><v-icon>mdi-link-variant</v-icon></v-btn
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import RestaurantsService from '../../api/services/restaurants.service';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { Globals } from '../../modules/Globals';
  import { getTopLevelDomain } from '@/utils/domain.utils';

  @Component
  export default class MapPopupRestaurant extends Vue {
    @Prop() restaurantId: number;
    uploadsPath = Globals.uploadsPath;
    restaurantsService = new RestaurantsService();
    restaurant: IRestaurant = null;
    imgSize = 50;
    domain = getTopLevelDomain();

    async created() {
      this.restaurant = await this.restaurantsService.getById(
        this.restaurantId
      );
    }
  }
</script>
